import { initialStateBase, reducer } from './newCollection';
import { getType } from './helpers/typeModifier';

export const urls = {
    getCover: category => `/api/cover/${category}`
};

export const TYPE = 'COVER';

const transformElementAction = (state, action) => {
    return {
        ...action,
        data: {
            ...action.data,
            data: action.data.data.map((section, i) => {
                const fakeId = `${action.url}-${i}`;

                switch (section.type) {
                    case 'item-carousel': {
                        const { items, id, ...rest } = section; // eslint-disable-line no-unused-vars

                        return {
                            ...rest,
                            id: id || fakeId
                        };
                    }

                    default:
                        return section.id
                            ? section
                            : {
                                ...section,
                                id: fakeId
                            };
                }
            })
        }
    };
};

export default (state = initialStateBase, action) => {
    switch (action.type) {
        case `CLEAR_ERROR_${TYPE}`:
            return {
                ...state,
                isError: {
                    ...state.isError,
                    [getType('COVER', action.url)]: false
                }
            };
        case `RECEIVE_${TYPE}`:
            return reducer(state, transformElementAction(state, action), TYPE);
        default:
            return reducer(state, action, TYPE);
    }
};
